<template>
  <div
    class="bg-login vw-100 vh-100 d-flex justify-content-center align-items-center p-4 overflow-auto"
  >
    <div class="login-form">
      <div class="login-logo-container">
        <img
          class="login-logo"
          src="@/assets/images/logo-sesb.png"
          v-if="currentUrl == 'https://sesb-api.inference.asia'"
        />
        <img class="login-logo" src="@/assets/images/ilsas-logo.png" v-else />
      </div>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          id="identifier"
          placeholder="Username or email"
          v-model="models.identifier"
        />
      </div>
      <div class="form-group">
        <input
          type="password"
          class="form-control"
          id="password"
          placeholder="Password"
          v-model="models.password"
        />
      </div>
      <p class="text-center text-danger small" v-if="showErrorMessage">
        {{ errorMessage }}
      </p>
      <button
        type="button"
        class="btn btn-success btn-block mb-3"
        :disabled="formIsDirty"
        @click="doLogin()"
      >
        <span class="small">Sign in to Dashboard</span>
      </button>
      <!-- <p class="login-footer">Powered by <strong>TNB-ILSAS</strong></p> -->
    </div>
  </div>
</template>

<script>
import API from "@/api.js";

export default {
  name: "login",
  data() {
    return {
      showErrorMessage: false,
      errorMessage: "",
      models: {
        identifier: "",
        password: "",
      },
      currentUrl: process.env.VUE_APP_API_URL,
    };
  },
  computed: {
    formIsDirty() {
      if (!this.models.identifier || !this.models.password) {
        return true;
      }
      return false;
    },
  },
  methods: {
    doLogin() {
      this.$emit("isLoading", true);
      API.post("auth/local", this.models)
        .then((retVal) => {
          this.showErrorMessage = false;

          localStorage.setItem("token", retVal.data.jwt);

          let u = {
            _id: retVal.data.user._id,
            company: retVal.data.user.company,
            email: retVal.data.user.email,
            username: retVal.data.user.username,
            district: retVal.data.user.district || "",
            isManager: retVal.data.user.isManager,
          };

          localStorage.setItem("user", JSON.stringify(u));

          if (this.$route.query && this.$route.query.nextUrl) {
            this.$router.push({ path: this.$route.query.nextUrl });
          } else {
            this.$router.push({ name: "dashboard" });
          }

          this.$emit("isLoading", false);
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.errorMessage = "Invalid username / password";
          } else {
            this.errorMessage = "Something went wrong. Please contact admin.";
          }
          this.showErrorMessage = true;
          this.$emit("isLoading", false);
        });
    },
  },
};
</script>
